export const GET_COUPON = "GET_COUPON";
export const SET_COUPON = "SET_COUPON";
export const COUPON_FAIL = "COUPON_FAIL";

export const CLEAR_COUPON = "CLEAR_COUPON";